<div class="tab-pane engine__tab-pane fade show active" id="parking" role="tabpanel" aria-labelledby="parking-tab">
  <form class="search-form" name="parking" #form="ngForm">
    <div class="search-form__engine">
      <div class="search-form__select search-form__select--col search-form__element p-0">
        <div class="form-group-custom">
          <label for="inputWhereParking" class="input-group-zeus__label">Dove</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="inputWhereParking-select">
            <ng-select [items]="locations$ | async" [typeahead]="locationQuery$"
                       name="location"
                       required
                       placeholder="Dove"
                       [loading]="isLoading" [(ngModel)]="selectedLocation"
                       [minTermLength]="3" typeToSearchText="Scrivi 3 o piu' caratteri"
                       id = "inputWhereParking"
                       class="form-control-custom">
              <ng-template ng-label-tmp let-item="item">
                <span>{{getParkingItemName(item) | stripTags}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [innerHTML]="getParkingItemName(item)"></span>
              </ng-template>
            </ng-select>
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon1"><i class="icon-pin"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__select search-form__element">
        <div class="form-group-custom">
          <label for="parkingWithdrawal-input" class="input-group-zeus__label">Ritiro</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="parkingWithdrawal-input">
            <input readonly [(ngModel)]="selectedCheckinDate"
                   required
                   name="checkin"
                   type="text"
                   placeholder="Ritiro"
                   ngbDatepicker #dpA="ngbDatepicker" (click)="dpA.toggle()"
                   class="form-control-custom">
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i class="icon-date"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__hour search-form__element">
        <div class="form-group-custom">
          <label for="parkingWithdrawalHour" class="input-group-zeus__label">Orario</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="parkingWithdrawalHour-select">
            <ng-select [(ngModel)]="selectedCheckinTime" [items]="times"
                       name="checkinTime"
                       required
                       id = "parkingWithdrawalHour"
                       class="form-control-custom">
              <ng-template ng-header-tmp>
                <span>Orario Ritiro...</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span>{{getTimeItemName(item) | stripTags}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [innerHTML]="getTimeItemName(item)"></span>
              </ng-template>
            </ng-select>
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon3"><i class="icon-clock"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__select search-form__element">
        <div class="form-group-custom">
          <label for="parkingReturn-input" class="input-group-zeus__label">Riconsegna</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="parkingReturn-input">
            <input readonly [(ngModel)]="selectedCheckoutDate"
                   type="text"
                   name="checkout"
                   required
                   placeholder="Riconsegna"
                   ngbDatepicker #dpR="ngbDatepicker" (click)="dpR.toggle()"
                   class="form-control-custom">
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon4"><i class="icon-date"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="search-form__hour search-form__element">
        <div class="form-group-custom">
          <label for="parkingReturnHour" class="input-group-zeus__label">Orario</label>
          <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent" id="parkingReturnHour-select">
            <ng-select [(ngModel)]="selectedCheckoutTime" [items]="times"
                       name="checkoutTime"
                       required
                       id = "parkingReturnHour"
                       class="form-control-custom">
              <ng-template ng-header-tmp>
                <span>Orario Riconsegna...</span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span>{{getTimeItemName(item) | stripTags}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [innerHTML]="getTimeItemName(item)"></span>
              </ng-template>
            </ng-select>
            <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
              <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon5"><i class="icon-clock"></i></span>
            </div>
          </div>
        </div>
      </div>
      <button [disabled]="form.invalid" (click)="doSearch()"
              class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3">Cerca <i class="icon-search"></i></button>
    </div>
  </form>
</div>
